// extracted by mini-css-extract-plugin
export var baseButton = "_w1-0";
export var controlsArrowKeys = "_w1-1";
export var controlsResetButton = "_w1-2";
export var lightGameButton = "_w1-4 _w1-0";
export var playAgainButton = "_w1-5 _w1-0";
export var startGameButton = "_w1-3 _w1-0";